// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_Xz5","title":"styles_title__bQVyc"};